// @ts-nocheck 03d7f7ce
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import * as core from '#packages/core';
import { EditorSubType } from '@wix/platform-editor-sdk';
import * as util from '#packages/util';
import * as stateManagement from '#packages/stateManagement';
import * as helpIds from '#packages/helpIds';
import { translate } from '#packages/i18n';
import * as panels from '#packages/panels';
import * as leftBar from '#packages/leftBar';
import * as appMarketUtils from '../appMarket/utils/appMarketUtils';
import * as appMarketHandlers from '../appMarket/appMarketHandlers';
import * as bi from '../bi/bi';
import { AppsPanelSectionsApiKey } from '#packages/appsPanelSections';
import { VerticalTabs } from '@wix/wix-base-ui';
import experiment from 'experiment';
import { ManageAppsEditor } from '@wix/manage-apps-editor';

const APP_MARKET_ORIGIN_PARAM = '&origin=editor';
const { getPreviewPosition } = stateManagement.domMeasurements.selectors;
const MANAGE_APPS_PATH = 'MANAGE_APPS';
const MANAGE_APPS_ROUTE = {
  path: MANAGE_APPS_PATH,
  payload: { hideMenu: true },
};
const SECTIONS_IDS = {
  MANAGE_APPS: 'manage-apps-section',
  APP_MARKET: 'app-market-section',
};

function getAppMarketUrl(editorAPI, urlParamsProps) {
  let urlParams = {};
  if (urlParamsProps.openMarketOrigin === 'market_button') {
    urlParams = appMarketUtils.getAppMarketUrlParams();
  }
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/assign
  _.assign(urlParams, urlParamsProps);
  urlParams.origin = appMarketUtils.origin();
  urlParams.newUrl = true;
  urlParams.state =
    appMarketUtils.getAppMarketSessionUserPrefs(editorAPI)?.state ?? '';
  const appMarketURL = editorAPI.dsRead.tpa.appMarket.getUrl(urlParams);
  return appMarketURL + APP_MARKET_ORIGIN_PARAM;
}

const getEditorAPI = (dispatch, getState, { editorAPI }) => editorAPI;

function mapDispatchToProps(dispatch) {
  const editorAPI = dispatch(getEditorAPI);

  return {
    appMarketHandlers: {
      closeAppMarket: () => appMarketHandlers.closeAppMarket(editorAPI),
      openAppMarketHelp: () => appMarketUtils.openAppMarketHelp(editorAPI),
      openBMInEditor: (path) =>
        appMarketHandlers.openBMInEditor(editorAPI, path),
      getUserDetails: (callback) =>
        appMarketHandlers.getUserDetails(editorAPI, {}, callback),
      getPendingAppsList: (callback) =>
        appMarketHandlers.getPendingAppsList(editorAPI, {}, callback),
      addApp: (options) => appMarketHandlers.addApp(editorAPI, options),
      appIsInstalled: (options, callback) =>
        appMarketHandlers.appIsInstalled(editorAPI, options, callback),
      removePendingApp: (options) =>
        appMarketHandlers.removePendingApp(editorAPI, options),
      uninstallPlatformApp: (appDefinitionId) =>
        appMarketHandlers.uninstallPlatformApp(editorAPI, appDefinitionId),
      addPendingApp: (options) =>
        appMarketHandlers.addPendingApp(editorAPI, options),
      save: (options, callback) =>
        appMarketHandlers.save(editorAPI, options, callback),
      deleteApp: (options, callback) =>
        appMarketHandlers.deleteApp(editorAPI, options, callback),
      openApp: (options) => appMarketHandlers.openApp(editorAPI, options),
      updateApp: (options, callback) =>
        appMarketHandlers.updateApp(editorAPI, options, callback),
      setAppMarketState: (options) =>
        appMarketHandlers.setAppMarketState(editorAPI, options),
      isDevMode: (options, callback) =>
        appMarketHandlers.isDevMode(editorAPI, options, callback),
      getDataByAppDefId: (appDefinitionId) =>
        editorAPI.dsRead.tpa.app.getDataByAppDefId(appDefinitionId),
      getUserGeo: () => editorAPI.dsRead.generalInfo.getGeo(),
      showUserActionNotification: (options) =>
        editorAPI.showUserActionNotification(options),
    },
  };
}

// eslint-disable-next-line react/prefer-es6-class
const AppMarketPanel = createReactClass({
  displayName: 'AppMarketPanel',
  propTypes: {
    urlParams: PropTypes.shape({
      openMarketOrigin: PropTypes.string.isRequired, //BI - will be sent as referralInfo
      referralInfoCategory: PropTypes.string, //BI - will be sent as referralInfoCategory
      section: PropTypes.string, //BI - at the moment can only be related apps
      openAppDefId: PropTypes.string, //used to open app market with specific app
      appDefinitionId: PropTypes.string, //used to open app market with developer apps section on the specified app
      categorySlug: PropTypes.string, //from editor url - used to open app market on specific category
      query: PropTypes.string, //from editor url - used to open app market with search term
      tags: PropTypes.string,
      tests: PropTypes.string,
      appMarketParams: PropTypes.string,
      slug: PropTypes.string,
      marketRoute: PropTypes.string,
    }).isRequired,
    helpId: PropTypes.string.isRequired,
  },
  mixins: [core.mixins.editorAPIMixin],
  getInitialState() {
    const appsPanelSections = [
      {
        sectionId: SECTIONS_IDS.APP_MARKET,
        label: translate('AddApps__LeftPanel__AppMarket'),
        headerText: translate('app_market_title'),
        component: () => {
          const Marketplace = this.marketplaceClass;
          return <Marketplace {...this.getMarketPlaceProps()} />;
        },
      },
      ...this.props.contributedSections,
      {
        sectionId: SECTIONS_IDS.MANAGE_APPS,
        label: translate('AddApps__LeftPanel__AppMarket_ManageApps'),
        headerText: translate('app_market_manage_apps_title'),
        component: () => {
          if (experiment.isOpen('specs.dcc.newManageAppsInEditor')) {
            const ManageApps = this.connectPanelComponent(ManageAppsEditor);
            return <ManageApps {...this.getManageAppsProps()} />;
          }
          const Marketplace = this.marketplaceClass;
          return <Marketplace {...this.getMarketPlaceProps()} />;
        },
      },
    ];
    return {
      appsPanelSections,
      appMarketUrl: getAppMarketUrl(this.getEditorAPI(), this.props.urlParams),
      selectedSection: appsPanelSections[0],
      loading: true,
      route: undefined,
      tabChanged: false,
    };
  },

  connectPanelComponent(panel) {
    const Connected = util.hoc.connect(
      util.hoc.STORES.EDITOR_API,
      {},
      mapDispatchToProps,
    )(panel);
    Connected.pure = panel;
    return Connected;
  },
  getNewAppMarket() {
    if (!this.marketplaceClass) {
      import('marketplace').then((marketplace) => {
        if (marketplace) {
          this.marketplaceClass = this.connectPanelComponent(
            marketplace.Marketplace.marketplace,
          );
          this.UpgradeAppButtonComponent = this.connectPanelComponent(
            marketplace.Marketplace.UpgradeAppButton,
          );
          this.AppsSectionComponent = this.connectPanelComponent(
            marketplace.Marketplace.AppsSection,
          );
          this.setState({ loading: false });
        }
      });
    }
  },
  onRouteChange(route) {
    if (route?.path === MANAGE_APPS_PATH) {
      this.onSectionChanged(SECTIONS_IDS.MANAGE_APPS, {
        ...route,
        // remove once se_addManageAppsToMarketPanel is merged so app market will remove the menu for all cases automatically
        payload: { ...(route.payload || {}), hideMenu: true },
      });
    } else {
      this.onSectionChanged(SECTIONS_IDS.APP_MARKET, route);
    }
  },
  getCommonPanelComponentProps() {
    const metaSiteId = this.getEditorAPI().dsRead.generalInfo.getMetaSiteId();
    const isPremium = this.getEditorAPI().site.isPremium();
    const locale = util.languages.getLanguageCode();
    const userId = this.getEditorAPI().dsRead.generalInfo.getUserInfo().userId;
    return {
      metaSiteId,
      locale,
      userId,
      onRouteChange: this.onRouteChange,
      isPremium,
      editorType: EditorSubType.Classic,
    };
  },
  getManageAppsProps() {
    return {
      ...this.getCommonPanelComponentProps(),
      appMarketComponents: {
        UpgradeAppButton: this.UpgradeAppButtonComponent,
        AppsSection: this.AppsSectionComponent,
      },
      appMarketParams: this.props.urlParams.appMarketParams,
    };
  },
  getMarketPlaceProps() {
    const marketplaceStaticsUrl =
      util.serviceTopology.scriptsLocationMap['marketplace-component'];
    const manageInstalledAppsUrl =
      util.serviceTopology.scriptsLocationMap['manage-installed-apps'];

    const initialUrlParams = this.state.tabChanged
      ? {}
      : {
          appMarketParams: this.props.urlParams.appMarketParams,
          openAppDefId: this.props.urlParams.openAppDefId,
          slug: this.props.urlParams.slug,
          openMarketOrigin: this.props.urlParams.openMarketOrigin,
          marketRoute: this.props.urlParams.marketRoute,
        };

    return {
      ...this.getCommonPanelComponentProps(),
      marketplaceStaticsUrl,
      config: {
        topology: {
          marketplaceStaticsUrl,
          manageInstalledAppsUrl,
        },
      },
      isAppManagerOpen: true,
      routeBaseName: '',
      ...initialUrlParams,
      route: this.state.route,
    };
  },
  getDefaultProps() {
    return {
      panelName: 'tpa.compPanels.appMarketPanel',
      helpId: helpIds.EXTERNAL.APP_MARKET,
    };
  },
  timeMarketOpened: undefined,
  openMarketOrigin: undefined,
  getTime() {
    return Date.now();
  },
  componentDidMount() {
    this.timeMarketOpened = this.getTime();
    this.openMarketOrigin =
      this.props.urlParams && this.props.urlParams.openMarketOrigin;
    this.getNewAppMarket();
    if (this.props.selectedSection?.id) {
      this.onSectionChanged(this.props.selectedSection?.id);
    }
  },
  componentWillUnmount() {
    const params = {
      open_origin: this.openMarketOrigin,
      seconds_opened: parseInt(
        (this.getTime() - this.timeMarketOpened) / 1000,
        10,
      ),
    };
    this.getEditorAPI().bi.event(bi.events.MARKET_CLOSED, params);
  },
  getPanelProps() {
    return {
      urlParams: this.props.urlParams,
      onHelpClicked: this.onHelpClicked,
      helpId: this.state?.selectedSection?.helpId || this.props.helpId,
    };
  },
  getResponsiveWidth() {
    const state = this.getEditorAPI().store.getState();
    const previewWidth = getPreviewPosition(state).width;
    let containerWidth;

    if (util.workspace.isNewWorkspaceEnabled()) {
      const MIN_WIDTH = 1200;
      const MAX_WIDTH =
        1600 + (this.props.contributedSections?.length > 0 ? 150 : 0);
      const width = previewWidth * 0.96;

      containerWidth = Math.min(Math.max(width, MIN_WIDTH), MAX_WIDTH);
    } else {
      const MARGIN_WIDTH = 32;
      const LEFT_PANEL_MARGIN = 65;

      containerWidth = previewWidth - MARGIN_WIDTH - LEFT_PANEL_MARGIN;
    }

    return {
      width: `${containerWidth}px`,
    };
  },
  onHelpClicked() {
    const editorAPI = this.getEditorAPI();
    editorAPI.bi.event(bi.events.MARKET_HELP_CLICK);
  },
  onSectionChanged(sectionId: string, newRoute?) {
    const nextSection = this.state.appsPanelSections.find(
      (section) => section.sectionId === sectionId,
    );
    if (this.state.selectedSection?.sectionId === sectionId) {
      return;
    }
    const route =
      newRoute ||
      (sectionId === SECTIONS_IDS.MANAGE_APPS ? MANAGE_APPS_ROUTE : undefined);

    this.setState({
      selectedSection: nextSection,
      route,
      tabChanged: true,
    });
    nextSection?.onClick?.();
  },
  getSectionTitle() {
    return this.state.selectedSection.headerText;
  },
  render() {
    const LeftPanelFrame = util.workspace.isNewWorkspaceEnabled()
      ? leftBar.LeftPanelFrame
      : panels.frames.LeftPanelFrame;

    return (
      <LeftPanelFrame
        panelName={this.props.panelName}
        label={this.getSectionTitle()}
        panelClass="app-market-panel-new"
        disableBlockingScroll={true}
        panelIndex={this.props.panelIndex}
        styleOverride={this.getResponsiveWidth()}
        className="app-market-content-new"
        fullHeight
        {...this.getPanelProps()}
      >
        {!this.state.loading
          ? (() => {
              const CurrentPanel = this.state.selectedSection.component;
              return (
                <div className="app-market-frame-new">
                  {this.state.appsPanelSections.length > 1 ? (
                    <VerticalTabs
                      shouldTranslate={false}
                      value={this.state.selectedSection.sectionId}
                      onChange={this.onSectionChanged}
                      options={this.state.appsPanelSections.map((section) => ({
                        value: section.sectionId,
                        label: section.label,
                        dataHook: `apps-tab-${section.sectionId}`,
                      }))}
                    />
                  ) : null}
                  <CurrentPanel {...this.props.selectedSection?.props} />
                </div>
              );
            })()
          : null}
      </LeftPanelFrame>
    );
  },
});

function mapStateToProps({ editorAPI }) {
  const appPanelSectionsApi = editorAPI.host.getAPI(AppsPanelSectionsApiKey);
  return {
    contributedSections: appPanelSectionsApi.getContributedSections(),
  };
}

export default util.hoc.connect(
  util.hoc.STORES.EDITOR_API,
  mapStateToProps,
  {},
)(AppMarketPanel);
